import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const NavigationComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "HeaderNavigationSettingsPage" */ "@circle-react/components/SettingsApp/Navigation"
    ),
);

export const Navigation = () => (
  <Suspense fallback={<PageLoader />}>
    <NavigationComponent />
  </Suspense>
);
